<app-modal-card [visible]="visible" (close)="close.emit()">
	<form [formGroup]="declineInfoForm" class="flex flex-col max-w-sm mx-1 my-6">
		<h3 class="mb-6" translate="counter-offer.decline-modal.title"></h3>
		<app-textarea [placeholder]="'counter-offer.decline-modal.placeholder' | translate" formControlName="reject_reason"></app-textarea>
		<app-button (action)="declineOffer()" [loading]="declineLoading">
			{{ 'counter-offer.decline-modal.button.text' | translate }}
		</app-button>
	</form>
</app-modal-card>
